import { FlexiSlider } from "appworks/graphics/elements/flexi-slider";
import { SliderElement } from "appworks/graphics/elements/slider-element";
import { Layers } from "appworks/graphics/layers/layers";
import { ControlFactory } from "appworks/ui/factories/control-factory";
import { AgsSingleWinLimitSliderControl } from "../ags-single-win-limit-slider-control";

export class AgsSingleWinLimitSliderControlFactory implements ControlFactory {
    public filter(layer: Layers): boolean {
        return (
            layer.getSprite("single_win_limit_slider_track") != null &&
            layer.getSprite("single_win_limit_slider_fill") != null &&
            layer.getSprite("single_win_limit_slider_handle") != null &&
            layer.getFlexiText("single_win_limit_slider_label") != null
        );
    }

    public build(layer: Layers): AgsSingleWinLimitSliderControl[] {
        const sliderElement = new SliderElement(
            layer,
            layer.getSprite("single_win_limit_slider_track"),
            layer.getSprite("single_win_limit_slider_fill"),
            layer.getSprite("single_win_limit_slider_handle")
        );

        const slider = new FlexiSlider();
        slider.addTarget(sliderElement);

        const title = layer.getFlexiText("single_win_limit_slider_title");
        const backgroundGraphic = layer.getSprite("bg_box_single_win_limit_slider");

        const label = layer.getFlexiText("single_win_limit_slider_label");
        return [new AgsSingleWinLimitSliderControl(slider, label, title, backgroundGraphic)];
    }
}
